import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { Description, HeaderElem } from '@/components/LoginHeader/styles'
import { Wrapper } from '@/components/SessionStatusView/styles'
import {
  LoginWrapper,
  QrContainerLogin,
  RegisterContainer,
  SessionContainer,
} from '@/containers/Auth/styles'
import { QrContainerBg } from '@/containers/styles'

export const AuthPopupContainer = styled(FocusNode)`
  position: fixed;
  background: ${(props) => props.theme.colors.dialogPopup.overlay};
  height: 1080px;
  width: 1920px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 13;
  ${RegisterContainer} {
    height: 100%;
    margin: 0 auto;
  }
  ${LoginWrapper}, ${SessionContainer} {
    padding: 0;
    background: none;
    margin: 0 auto;
  }
  ${HeaderElem} {
    min-height: 160px;
    padding: 40px 40px 0;
  }
  ${Description} {
    padding-bottom: 0;
  }
  ${Wrapper}, ${QrContainerBg} {
    margin: 40px auto;
  }
  ${QrContainerLogin} {
    margin: 0 auto;
  }
`

export const AuthPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 1070px;
  height: 920px;
  background: linear-gradient(
    108deg,
    ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
    ${(props) => props.theme.colors.dialogPopup.background.end} 100%
  );
  padding: 24px;
  border-radius: 24px;
  overflow: hidden;
`

export const ContentContainer = styled(FocusNode)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 290px;
  flex: 1 1;
`

export const ActionsWrapper = styled.div`
  min-height: 80px;
  width: 100%;
  position: relative;
`
export const Actions = styled.div<{ $isDisabled: boolean }>`
  display: flex;
  align-self: flex-end;
  justify-content: center;
  width: 100%;
  height: 80px;
  opacity: ${(props) => (props.$isDisabled ? '0.5' : '1')};
`
